var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.211,
    height: 23.211,
    viewBox: "0 0 23.211 23.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M15.606,15.606A5.8,5.8,0,1,0,9.8,9.8,5.8,5.8,0,0,0,15.606,15.606Zm0,2.9C11.732,18.507,4,20.451,4,24.31v2.9H27.211v-2.9C27.211,20.451,19.479,18.507,15.606,18.507Z",
    transform: "translate(-4 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.fdc17750495224463c03ece9ccb53d15.svg";
export { ForwardRef as ReactComponent };